import { QuickBuyDrawer, LineItemQuantity, ProductForm, VariantPicker } from "//www.planetbox.com/cdn/shop/t/280/assets/theme.js?v=72864582119464715381764662762";

class LTBQuickBuyDrawer extends QuickBuyDrawer {
  constructor() {
    super(); // Call the parent class constructor
    this._lastLoadedVariantId = null;
  }

  // Override the show method
  async show() {
    const selectedVariantHandle = this.closest('.product-card').querySelector('a').getAttribute('href').substring(1);
    const variantMatch = selectedVariantHandle.match(/variant=([^&]+)/);
    const selectedVariantId = variantMatch ? variantMatch[1] : null;
    this.style.display = "block";
    if (!this._hasLoaded || this._lastLoadedVariantId !== selectedVariantId) {
      this._hasLoaded = false; // Reset the hasLoaded flag if the variant has changed
      this._lastLoadedVariantId = selectedVariantId; // Update the last loaded variant ID
      [this, ...this.controls].forEach((control) => control.setAttribute("aria-busy", "true"));
      const responseContent = await (await fetch(`${window.Shopify.routes.root}${selectedVariantHandle}`)).text();
      [this, ...this.controls].forEach((control) => control.setAttribute("aria-busy", "false"));
      const quickBuyContent = new DOMParser().parseFromString(responseContent, "text/html").getElementById("quick-buy-content").content;
      Array.from(quickBuyContent.querySelectorAll("noscript")).forEach((noScript) => noScript.remove());
      // Removed shopify-app-blocks we'll need to find a better solution when we have more time...
      Array.from(quickBuyContent.querySelector("div.quick-buy-drawer__info").querySelectorAll(".shopify-app-block")).forEach((block) => block.remove());
      this.replaceChildren(quickBuyContent);
      Shopify.PaymentButton?.init();
      this._hasLoaded = true;
    }
    return super.show();
  }
}
if (!window.customElements.get("ltb-quick-buy-drawer")) {
  window.customElements.define("ltb-quick-buy-drawer", LTBQuickBuyDrawer);
}

class LTBLineItemQuantity extends LineItemQuantity {
  constructor() {
    super(); // Call the parent class constructor
  }

  // Override the changeLineItemQuantity method
  async _changeLineItemQuantity(lineKey, targetQuantity) {
    if (window.themeVariables.settings.pageType === "cart") {
      window.location.href = `${Shopify.routes.root}cart/change?id=${lineKey}&quantity=${targetQuantity}`;
    } else {
      const lineItem = this.closest("line-item");
      lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", { bubbles: true, detail: { targetQuantity } }));
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      const originalCart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      const itemToRemove = originalCart["items"].find(item => item.key === lineKey);
      const isBundleItem = itemToRemove?.properties?.Discount === 'Bundle';
      var cartContent = await (await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: targetQuantity,
          sections: sectionsToBundle
        })
      })).json();
      var lineItemAfterChange = cartContent["items"].filter((lineItem2) => lineItem2["key"] === lineKey);
      lineItem?.dispatchEvent(new CustomEvent("line-item:change", {
        bubbles: true,
        detail: {
          quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0]["quantity"],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "line-item:change",
          cart: cartContent
        }
      }));

      var wasRemoved = lineItemAfterChange.length === 0;
      if (wasRemoved) {
        this._triggerRemoveItemEvent(cartContent.items_removed[0]);
        if (isBundleItem) {
          const itemsToUpdate = cartContent["items"].filter(item =>
            item.properties?.Discount === 'Bundle'
          );
          for (const item of itemsToUpdate) {
            const newProperties = { ...item.properties };
            delete newProperties.Discount;
            await fetch(`${Shopify.routes.root}cart/change.js`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: item.key,
                quantity: 0
              })
            });
            await fetch(`${Shopify.routes.root}cart/add.js`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: item.variant_id,
                quantity: item.quantity,
                properties: newProperties
              })
            });
          }
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      }
    }
  }
  _triggerRemoveItemEvent(item) {
    let removeItem = {
      event: "bva_remove_from_cart",
      event_id:
        new Date().getTime() + "." + Math.random().toString(36).substring(5),
      ecommerce: {
        currencyCode: themeVariables.settings.currency,
        remove: {
          actionField: { list: "cart" },
          products: [
            {
              id: item.variant_id,
              sku: item.sku.replace("'", ""),
              handle: item.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''),
              productId: item.product_id,
              variantId: item.variant_id,
              name: item.title.replace("'", ""),
              price: Number(item.price),
              brand: item.vendor.replace("'", ""),
              variant: (item.variant_title || item.title).replace("'", ""),
              quantity: item.quantity,
              category: item.product_type.replace("'", ""),
            },
          ],
        },
        items: [
          {
            item_id: item.variant_id,
            shopify_product_id: item.product_id,
            shopify_variant_id: item.variant_id,
            shopify_sku: item.sku.replace("'", ""),
            shopify_handle: item.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''),
            item_name: item.title.replace("'", ""),
            affiliation: themeVariables.settings.affiliation,
            currency: themeVariables.settings.currency,
            item_brand: item.vendor.replace("'", ""),
            item_category: item.product_type.replace("'", ""),
            item_list_id: "cart",
            item_list_name: "cart",
            item_variant: (item.variant_title || item.title).replace("'", ""),
            Color: (item.variant_title || item.title).replace("'", ""),
            price: Number(item.price),
          },
        ],
      },
    };

    dataLayer.push({ ecommerce: null });
    dataLayer.push(removeItem);
  }
}
if (!window.customElements.get("ltb-line-item-quantity")) {
  window.customElements.define("ltb-line-item-quantity", LTBLineItemQuantity);
}

class LTBProductForm extends ProductForm {
  constructor() {
    super();
  }

  // Override the _onSubmit method
  async _onSubmit(event) {
    event.preventDefault();
    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }
    const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");
    submitButtons.forEach((submitButton) => {
      submitButton.setAttribute("disabled", "disabled");
      submitButton.setAttribute("aria-busy", "true");
    });
    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    const formData = new FormData(this);
    formData.set("sections", sectionsToBundle.join(","));
    formData.set("sections_url", `${Shopify.routes.root}variants/${this.id.value}`);
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: formData,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
        // Needed for Shopify to check inventory
      }
    });
    submitButtons.forEach((submitButton) => {
      submitButton.removeAttribute("disabled");
      submitButton.removeAttribute("aria-busy");
    });
    const responseJson = await response.json();
    if (response.ok) {
      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        return window.location.href = `${Shopify.routes.root}cart`;
      }
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent["sections"] = responseJson["sections"];
      this.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent
        }
      }));
      this._dataLayerSubmit(responseJson.hasOwnProperty("items") ? responseJson["items"][0] : [responseJson][0]);
    } else {
      this.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: {
          error: responseJson["description"]
        }
      }));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
  }
  _dataLayerSubmit(variantAdded) {
    // DATALAYER - ADD TO CART EVENT
    let additem = {};
    const addItemArry = [];
    Object.keys(variantAdded.options_with_values).forEach((i) => {
      const objName = variantAdded.options_with_values[i].name;
      const objVal = variantAdded.options_with_values[i].values;
      additem = {
        'item_id': variantAdded.variant_id,
        'shopify_product_id': variantAdded.product_id,
        'shopify_variant_id': variantAdded.variant_id,
        'shopify_sku': variantAdded.sku.replace("'", ""),
        'shopify_handle': variantAdded.handle,
        'shopify_compare_price': (variantAdded.compare_at_price || variantAdded.price) / 100,
        'item_name': variantAdded.product_title.replace("'", ""),
        'affiliation': themeVariables.settings.affiliation,
        'currency': themeVariables.settings.currency,
        'item_brand': variantAdded.vendor.replace("'", ""),
        'item_category': variantAdded.product_type.replace("'",""),
        item_list_id: "product",
        item_list_name: "product",
        'item_variant': (variantAdded.variant_title || variantAdded.title).replace("'",""),
        [objName] : (variantAdded.variant_title || variantAdded.title).replace("'",""),
        'price': (variantAdded.price / 100),
      }
    });

    addItemArry.push(additem);

    let addItemToCart = {
      'event': 'bva_add_to_cart',
      'event_id': new Date().getTime() + '.' + Math.random().toString(36).substring(5),
      'ecommerce': {
        'currencyCode': themeVariables.settings.currency,
        'add': {
          'actionField': {'list': 'product'},
          'products': [{
            'id': variantAdded.variant_id,
            'sku': variantAdded.sku,
            'handle': variantAdded.handle,
            'productId': variantAdded.product_id,
            'variantId': variantAdded.variant_id,
            'name' : variantAdded.product_title.replace("'", ""),
            'price': (variantAdded.price / 100),
            'brand' : variantAdded.vendor.replace("'", ""),
            'variant': (variantAdded.variant_title || variantAdded.title).replace("'", ""),
            'category': variantAdded.product_type.replace("'",""),
          }]
        },
        'items': addItemArry
      }
    }

    dataLayer.push({ ecommerce: null });
    dataLayer.push(addItemToCart);
  }
};
if (!window.customElements.get("ltb-product-form")) {
  window.customElements.define("ltb-product-form", LTBProductForm, { extends: "form" });
}

class LTBVariantPicker extends VariantPicker {
  constructor() {
    super();
   
    if (this.closest("section.shopify-section--main-product")) {
      requestAnimationFrame(() => {
        setTimeout(() => {
          if (this.selectedVariant && this.product) {
            this._dataLayerSelectVariant(this.product, this.selectedVariant);
          }
        }, 1000);
      });
    }
  }

  // Override the selectVariant method
  selectVariant(id) {
    if (!this._isVariantSelectable(this._getVariantById(id))) {
      id = this._getFirstMatchingAvailableOrSelectableVariant()["id"];
    }
    const previousVariant = this.selectedVariant;
    if (previousVariant && previousVariant.id === id) {
      return;
    }
    this.masterSelector.value = id;
    this.masterSelector.dispatchEvent(new Event("change", { bubbles: true }));
    if (this.updateUrl && history.replaceState) {
      const newUrl = new URL(window.location.href);
      if (id) {
        newUrl.searchParams.set("variant", id);
      } else {
        newUrl.searchParams.delete("variant");
      }
      window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
    }
    this._updateDisableSelectors();
    this._dataLayerSelectVariant(this.product, this.selectedVariant);
    this.masterSelector.form.dispatchEvent(new CustomEvent("variant:change", {
      bubbles: true,
      detail: {
        product: this.product,
        variant: this.selectedVariant,
        previousVariant
      }
    }));
  }
  _dataLayerSelectVariant(newProduct, newProductVariant) {
    let itemchange = {};
    const itemArryChange = [];
    Object.keys(newProduct.options).forEach((i) => {
      const objName = newProduct.options[i].name;
      const objVal = newProduct.options[i].values;
      itemchange = {
        item_id: newProductVariant.id,
        shopify_product_id: newProduct.id,
        shopify_variant_id: newProductVariant.id,
        shopify_sku: newProductVariant.sku.replace("'", ""),
        shopify_handle: newProduct.handle,
        shopify_compare_price:
          (newProductVariant.compare_at_price || newProductVariant.price) / 100,
        item_name: newProduct.title.replace("'", ""),
        affiliation: themeVariables.settings.affiliation,
        currency: themeVariables.settings.currency,
        item_brand: newProduct.vendor.replace("'", ""),
        item_category: newProduct.type.replace("'", ""),
        item_list_id: "product",
        item_list_name: "product",
        item_variant: newProductVariant.title.replace("'", ""),
        [objName]: objVal,
        price: newProductVariant.price / 100,
      };
    });
    itemArryChange.push(itemchange);
    let viewItemChange = {
      event: "bva_view_item",
      event_id:
        new Date().getTime() + "." + Math.random().toString(36).substring(5),
      ecommerce: {
        currencyCode: themeVariables.settings.currency,
        detail: {
          actionField: { list: "product" },
          products: [
            {
              id: newProductVariant.id,
              sku: newProductVariant.sku,
              handle: newProduct.handle,
              productId: newProduct.id,
              variantId: newProductVariant.id,
              name: newProduct.title.replace("'", ""),
              price: newProductVariant.price / 100,
              brand: newProduct.vendor.replace("'", ""),
              variant: newProductVariant.title.replace("'", ""),
              category: newProduct.type.replace("'", ""),
            },
          ],
        },
        items: itemArryChange,
      },
    };

    dataLayer.push(viewItemChange);
  }
};
if (!window.customElements.get("ltb-variant-picker")) {
  window.customElements.define("ltb-variant-picker", LTBVariantPicker);
}